import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import UserPage from 'flarum/forum/components/UserPage';
import app from 'flarum/forum/app';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
import EditCustomPageModal from '../components/EditCustomPageModal';
export default class CustomProfilePage extends UserPage {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "error", null);
    _defineProperty(this, "customPage", null);
    _defineProperty(this, "permissionDenied", false);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;
    this.error = null;
    this.customPage = null;
    this.permissionDenied = false;
    this.loadUser(m.route.param('username'));
  }
  show(user) {
    super.show(user);
    this.loadCustomPage();
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    this.processMediaLinks();
  }
  onupdate(vnode) {
    super.onupdate(vnode);
    this.processMediaLinks();
  }
  processMediaLinks() {
    var _app$forum;
    const enableMediaEmbeds = (_app$forum = app.forum) == null ? void 0 : _app$forum.attribute('huseyinfiliz-custom-profile-page.enable_media_embeds');
    if (!enableMediaEmbeds) {
      return;
    }
    setTimeout(() => {
      var _this$element;
      const content = (_this$element = this.element) == null ? void 0 : _this$element.querySelector('.CustomProfilePage-content');
      if (!content) return;
      const links = content.querySelectorAll('a[href*="youtube.com"], a[href*="youtu.be"]');
      links.forEach(link => {
        if (link.classList.contains('media-processed')) return;
        const url = link.getAttribute('href');
        if (!url) return;
        let videoId = null;
        try {
          const parsed = new URL(url);
          if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') return;
          if (['youtube.com', 'www.youtube.com', 'm.youtube.com'].includes(parsed.hostname) && parsed.pathname === '/watch') {
            videoId = parsed.searchParams.get('v');
          } else if (parsed.hostname === 'youtu.be') {
            videoId = parsed.pathname.slice(1);
          }
        } catch (_unused) {
          return;
        }
        if (videoId && /^[a-zA-Z0-9_-]{11}$/.test(videoId)) {
          const iframe = document.createElement('iframe');
          iframe.src = "https://www.youtube.com/embed/".concat(videoId);
          iframe.width = '560';
          iframe.height = '315';
          iframe.frameBorder = '0';
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
          iframe.allowFullscreen = true;
          iframe.style.maxWidth = '100%';
          iframe.style.marginTop = '10px';
          iframe.style.marginBottom = '10px';
          const parent = link.parentElement;
          if (parent) {
            parent.appendChild(iframe);
            link.classList.add('media-processed');
            link.style.display = 'none';
          }
        }
      });
    }, 100);
  }
  content() {
    var _app$forum2, _this$user, _app$forum3, _this$customPage2;
    if (this.loading) {
      return m(LoadingIndicator, null);
    }
    if (this.permissionDenied) {
      return m("div", {
        className: "CustomProfilePage"
      }, m("div", {
        className: "Placeholder"
      }, m("p", null, app.translator.trans('huseyinfiliz-custom-profile-page.forum.errors.permission_denied'))));
    }
    if (this.error) {
      return m("div", {
        className: "CustomProfilePage"
      }, m("div", {
        className: "Placeholder"
      }, m("p", null, this.error)));
    }
    const currentUser = app.session.user;
    if (!currentUser) {
      var _this$customPage;
      const contentHtml = ((_this$customPage = this.customPage) == null ? void 0 : _this$customPage.contentHtml()) || '';
      return m("div", {
        className: "CustomProfilePage"
      }, m("div", {
        className: "CustomProfilePage-content Post-body"
      }, contentHtml ? m.trust(contentHtml) : this.renderEmpty(false)));
    }
    const isModerator = (_app$forum2 = app.forum) == null ? void 0 : _app$forum2.attribute('canModerateCustomPage');
    const isOwnPage = currentUser.id() === ((_this$user = this.user) == null ? void 0 : _this$user.id());
    const canEditOwn = (_app$forum3 = app.forum) == null ? void 0 : _app$forum3.attribute('canEditOwnCustomPage');
    const canEdit = !!(isModerator || isOwnPage && canEditOwn);
    const contentHtml = ((_this$customPage2 = this.customPage) == null ? void 0 : _this$customPage2.contentHtml()) || '';
    return m("div", {
      className: "CustomProfilePage"
    }, m("div", {
      className: "CustomProfilePage-header"
    }, canEdit && m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-edit",
      onclick: () => {
        if (!this.user) return;
        app.modal.show(EditCustomPageModal, {
          user: this.user,
          customPage: this.customPage,
          onSave: page => {
            this.customPage = page;
            m.redraw();
          }
        });
      }
    }, app.translator.trans('huseyinfiliz-custom-profile-page.forum.profile_tab.edit_button'))), m("div", {
      className: "CustomProfilePage-content Post-body"
    }, contentHtml ? m.trust(contentHtml) : this.renderEmpty(canEdit)));
  }
  loadCustomPage() {
    if (!this.user) {
      setTimeout(() => this.loadCustomPage(), 100);
      return;
    }
    this.loading = true;
    this.error = null;
    this.permissionDenied = false;
    this.customPage = null;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/users/' + this.user.id() + '/custom-page'
    }).then(response => {
      if (response.data) {
        this.customPage = app.store.pushPayload(response);
      }
    }).catch(error => {
      if (error.status === 403) {
        this.permissionDenied = true;
      } else if (error.status === 404) {
        this.customPage = null;
      } else {
        this.error = app.translator.trans('huseyinfiliz-custom-profile-page.forum.errors.load_failed');
      }
    }).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }
  renderEmpty(canEdit) {
    return m("div", {
      className: "Placeholder"
    }, m("p", null, canEdit ? app.translator.trans('huseyinfiliz-custom-profile-page.forum.profile_tab.empty_own') : app.translator.trans('huseyinfiliz-custom-profile-page.forum.profile_tab.empty_other')));
  }
}
flarum.reg.add('huseyinfiliz-custom-profile-page', 'forum/pages/CustomProfilePage', CustomProfilePage);